import React from 'react';

function RankHeaderLabel(props) {
    return (
        <div style={{display: 'flex', gap: '4px'}}>
            <span style={{width: '20px', textAlign: 'center'}}>#</span>
            {props.children}
        </div>
    );
}

export default RankHeaderLabel;
